import React from "react";
import styled from "styled-components";
import { PathwayFormGrid } from "../../../../_UI/StyledComponents/PathwayForm";
import PathwayTextInputGroup from "../../../../_UI/Components/Inputs/PathwayTextInputGroup";
import { LoadingSpinnerButton, PathwayLinkButton } from "../../../../_UI/Components/PathwayButtons";
import LoadingSpinner from "../../../../_UI/Components/LoadingSpinner";
import PathwaySelectInputGroup from "../../../../_UI/Components/Inputs/PathwaySelectInputGroup";

const StripeMarketplaceExistingUserLogin = (props) => {
    return (
        <UserGrid>
            {!props.loginSubmitted && (
                <PathwayFormGrid>
                    <PathwayTextInputGroup
                        label={"Email"}
                        name={"email"}
                        handleChange={props.handleChange}
                        value={props.loginData.email || ""}
                        mandatory
                        autoFocus
                    />
                    <PathwayTextInputGroup
                        label={"Passwort"}
                        name={"password"}
                        type="password"
                        handleChange={props.handleChange}
                        value={props.loginData.password}
                        mandatory
                    />
                </PathwayFormGrid>
            )}
            {props.loginSubmitted && props.marketplaceSetup.loginLoading && (
                <LoadingGrid>
                    <LoadingSpinner center={true} loading={props.marketplaceSetup.loginLoading} />
                </LoadingGrid>
            )}
            {props.loginSubmitted &&
                !props.marketplaceSetup.loginLoading &&
                props.marketplaceSetup.existingUserAvailableOrgs && (
                    <SelectRow>
                        <PathwaySelectInputGroup
                            label="Bitte wähle das Konto aus, mit dem Du den neuen Shop verbinden möchtest."
                            name={"selectedOrganizationExternalUUID"}
                            handleChange={props.handleSelectOrgAndClientChange}
                            value={props.loginData.selectedOrganizationExternalUUID}
                            nullOptionValue="Bitte wählen Sie"
                        >
                            <option value="createNewOrganization">Neuen Account erstellen</option>
                            {props.marketplaceSetup.existingUserAvailableOrgs &&
                                props.marketplaceSetup.existingUserAvailableOrgs.map((org) => (
                                    <option key={org.externalUUID} value={org.externalUUID}>
                                        {org.name}
                                    </option>
                                ))}
                        </PathwaySelectInputGroup>
                    </SelectRow>
                )}
            <LoginRow>
                <br />
                <LoadingSpinnerButton
                    className="btn btn-block btn-primary"
                    onClick={props.submit}
                    loading={props.marketplaceSetup.loginLoading}
                    disabled={
                        props.marketplaceSetup.registrationErrorMessage ||
                        !props.loginData.password ||
                        !props.loginData.email ||
                        (props.loginSubmitted && props.loginData.selectedOrganizationExternalUUID === "")
                    }
                >
                    Login
                </LoadingSpinnerButton>
            </LoginRow>
            <PasswordRow>
                <div />
                <PathwayLinkButton className="px-0" onClick={props.toggleForgetPasswordModal}>
                    Passwort vergessen?
                </PathwayLinkButton>
            </PasswordRow>
        </UserGrid>
    );
};

export default StripeMarketplaceExistingUserLogin;
const UserGrid = styled.div`
    display: grid;
`;

const LoginRow = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
`;

const LoadingGrid = styled.div`
    display: grid;
    align-items: center;
`;

const SelectRow = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
`;

const PasswordRow = styled.div`
    display: grid;
    grid-template-columns: 0.6fr 0.4fr;
    align-items: center;
`;
